<template>
    <div class="col-md-12">
        <div class="filter_el best__item">
            <div class="item_count" v-if="!itemData.localItem">
                {{itemData.numbers}}
            </div>
            <div class="best_partner">
                <img src="../../../img/Badge.svg" alt="">
            </div>
            <div class="main__blck">

                <div class="logo__blck">
                    <div class="stiker__blck">
                        <img src="../../../img/clients/Kampanj_icn.png" alt="">
                    </div>
                    <div class="local__blck" v-if="itemData.localItem">
                        <span class="marker"><img src="/img/marker.svg" alt="">Stockholm</span>
                    </div>
                    <div class="logo">
                        <img src="../../../img/fortum.svg" alt="">
                    </div>
                    <div class="spec_items">
                        <div class="spec_item">
                            <div class="icon" :class="{'active': active3}">
                                <img src="../../../img/icon/weather/sun.svg" alt=""    @click="active3 = !active3">
                            </div>
                            <div class="mini-popup" v-if="active3"  :class="{'active': active3}">
                                <div class="m_popup__blck">
                                    <div class="title">
                                        <p class="Raleway min p-dgrey"><b>Fast price</b></p>
                                    </div>
                                    <div class="content">
                                        <p class="min-min p-dgrey">A variable ous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="spec_item">
                            <div class="icon" :class="{'active': active8}">
                                <img src="../../../img/icon/weather/bio.svg" alt=""    @click="active8 = !active8">
                            </div>
                            <div class="mini-popup" v-if="active8"  :class="{'active': active8}">
                                <div class="m_popup__blck">
                                    <div class="title">
                                        <p class="Raleway min p-dgrey"><b>Fast price</b></p>
                                    </div>
                                    <div class="content">
                                        <p class="min-min p-dgrey">A variable ous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="spec_item">
                            <div class="icon" :class="{'active': active4}">
                                <img src="../../../img/icon/weather/environment.svg" alt=""     @click="active4 = !active4">
                            </div>
                            <div class="mini-popup" v-if="active4"  :class="{'active': active4}">
                                <div class="m_popup__blck">
                                    <div class="title">
                                        <p class="Raleway min p-dgrey"><b>Fast price</b></p>
                                    </div>
                                    <div class="content">
                                        <p class="min-min p-dgrey">A variable ous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="spec_item">
                            <div class="icon" :class="{'active': active5}">
                                <img src="../../../img/icon/weather/water.svg" alt=""     @click="active5 = !active5">
                            </div>
                            <div class="mini-popup" v-if="active5"  :class="{'active': active5}">
                                <div class="m_popup__blck">
                                    <div class="title">
                                        <p class="Raleway min p-dgrey"><b>Fast price</b></p>
                                    </div>
                                    <div class="content">
                                        <p class="min-min p-dgrey">A variable ous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="spec_item">
                            <div class="icon" :class="{'active': active6}">
                                <img src="../../../img/icon/weather/wind.svg" alt=""     @click="active6 = !active6">
                            </div>
                            <div class="mini-popup" v-if="active6"  :class="{'active': active6}">
                                <div class="m_popup__blck">
                                    <div class="title">
                                        <p class="Raleway min p-dgrey"><b>Fast price</b></p>
                                    </div>
                                    <div class="content">
                                        <p class="min-min p-dgrey">A variable ous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="spec_item">
                            <div class="icon" :class="{'active': active7}">
                                <img src="../../../img/icon/weather/XLarge.png" alt=""     @click="active7 = !active7">
                            </div>
                            <div class="mini-popup" v-if="active7"  :class="{'active': active7}">
                                <div class="m_popup__blck">
                                    <div class="title">
                                        <p class="Raleway min p-dgrey"><b>Fast price</b></p>
                                    </div>
                                    <div class="content">
                                        <p class="min-min p-dgrey">A variable ous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="price__blck">
                    <div class="price_list">
                        <div class="price_item quest__in_parent">
                            <p class="p-light-green med">Variable price</p>
                            <div class="quest__in_icon" :class="{'active': active1}" @click="active1 = !active1">
                                <div class="mini-popup" v-if="active1"  :class="{'active': active1}"  @click="active1 = !active1">
                                    <div class="m_popup__blck">
                                        <div class="title">
                                            <p class="Raleway min p-dgrey"><b>Variable price</b></p>
                                        </div>
                                        <div class="content">
                                            <p class="min-min p-dgrey">A variable price follows developments on the Nordic electricity exchange (Nord Pool) and can vary considerably from month to month. The price to the left is based on the average value of the previous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="price_item">
                            <p class="p-bold">The terms apply</p>
                            <p class="bg-p">24 month</p>
                        </div>
                        <div class="price_item">
                            <p class="p-bold">Notice period</p>
                            <p class="bg-p">30 days</p>
                        </div>
                        <div class="price_item">
                            <p class="p-bold">Annual cost</p>
                            <p class="bg-p">5461 kr</p>
                        </div>
                    </div>
                    <div class="more">
                        <button
                                class="p-bold p-black"
                                @click="infOpen = !infOpen"
                                :class="{'infOpen':infOpen}"
                        >
                            <img src="../../../img/icon/more-plus.svg" alt="">  More information / calculation</button>

                    </div>
                    <transition name="fade">
                        <div class="info__blck" v-if="infOpen">
                            <div class="logo__blck">
                                <p class="p-bold title-p">More about Fortum</p>
                                <p class="min-min">Cheap, cheap and cheap. Then you can summarize Telinet Energi with three words. For us, the price is everything. At the same time, we never compromise on the environment: all our electricity is green and comes from renewable sources.</p>
                            </div>
                            <div class="price__blck">
                                <div class="price_info_item">
                                    <p class="p-bold title-p">Fixed charge</p>
                                    <p class="min-min">The regular fixed annual fee is SEK 420 incl. VAT </p>
                                </div>
                                <div class="price_info_item">
                                    <p class="p-bold title-p">Discount fixed fee</p>
                                    <p class="min-min">The anual fee is discounted SEK 420 / year incl. VAT for one year</p>
                                </div>
                                <div class="price_info_item">
                                    <p class="p-bold title-p">Discount penny / kWh</p>
                                    <p class="min-min">SEK 8.00 / kWh excluding VAT</p>
                                </div>
                            </div>
                            <div class="action__blck">
                                <div class="row">
                                    <div class="col-9">
                                        <div class="title">
                                            <p class="relawaySM min p-dgrey">Electricity price</p>
                                            <p class="p-gray2 minimum">(incl. electricity certificate, excl. VAT)</p>
                                        </div>
                                    </div>
                                    <div class="col-3 d-flex align-items-center justify-content-end">
                                        <div class="cost">
                                            <p class="p-dgrey med-max p-bold">45.90</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-9">
                                        <div class="title">
                                            <p class="relawaySM min p-dgrey"> Fixed feese</p>
                                            <p class="p-gray2 minimum">Monthly fee 36 SEK / month (excl. VAT)</p>
                                        </div>
                                    </div>
                                    <div class="col-3 d-flex align-items-center justify-content-end">
                                        <div class="cost">
                                            <p class="p-dgrey med-max p-bold">3.51</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-9">
                                        <div class="title">
                                            <p class="relawaySM min p-dgrey">Environmental Power on</p>
                                            <p class="p-gray2 minimum">No premium for environmental agreements</p>
                                        </div>
                                    </div>
                                    <div class="col-3 d-flex align-items-center justify-content-end">
                                        <div class="cost">
                                            <p class="p-dgrey med-max p-bold">0.00</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-9">
                                        <div class="title">
                                            <p class="relawaySM min p-dgrey">Moms</p>
                                            <p class="p-gray2 minimum">VAT, 25% </p>
                                        </div>
                                    </div>
                                    <div class="col-3 d-flex align-items-center justify-content-end">
                                        <div class="cost">
                                            <p class="p-dgrey med-max p-bold">+ 12.35</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </transition>

                </div>
                <div class="action__blck">

                    <div class="two__blcks">
                        <div class="res_elec">
                            <p class="p-black">
                                <span class="number">36,32 </span> <br />
                                <span>öre/kWh inkl</span>
                                <button @click="active2 = !active2" :class="{'active': active2}" class="p-blue">inkl</button>
                            </p>
                        </div>
                        <div class="res_price">
                            <p class="p-black">
                                <span class="number">1250</span>
                                <span>kr</span> <br />
                                <span>month SEK</span>
                            </p>
                        </div>
                        <div class="mini-popup"
                             v-if="active2"
                             :class="{'active': active2}"
                             @click="active2 = !active2">
                            <div class="m_popup__blck">
                                <div class="row">
                                    <div class="col-9">
                                        <div class="title">
                                            <p class="relawaySM min p-dgrey">Electricity price</p>
                                            <p class="p-gray2 minimum">(incl. electricity certificate, excl. VAT)</p>
                                        </div>
                                    </div>
                                    <div class="col-3 d-flex align-items-center justify-content-end">
                                        <div class="cost">
                                            <p class="p-dgrey med-max p-bold">45.90</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-9">
                                        <div class="title">
                                            <p class="relawaySM min p-dgrey"> Fixed feese</p>
                                            <p class="p-gray2 minimum">Monthly fee 36 SEK / month (excl. VAT)</p>
                                        </div>
                                    </div>
                                    <div class="col-3 d-flex align-items-center justify-content-end">
                                        <div class="cost">
                                            <p class="p-dgrey med-max p-bold">3.51</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-9">
                                        <div class="title">
                                            <p class="relawaySM min p-dgrey">Environmental Power on</p>
                                            <p class="p-gray2 minimum">No premium for environmental agreements</p>
                                        </div>
                                    </div>
                                    <div class="col-3 d-flex align-items-center justify-content-end">
                                        <div class="cost">
                                            <p class="p-dgrey med-max p-bold">0.00</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-9">
                                        <div class="title">
                                            <p class="relawaySM min p-dgrey">Moms</p>
                                            <p class="p-gray2 minimum">VAT, 25% </p>
                                        </div>
                                    </div>
                                    <div class="col-3 d-flex align-items-center justify-content-end">
                                        <div class="cost">
                                            <p class="p-dgrey med-max p-bold">+ 12.35</p>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                    <div class="buttons">
                        <button class="btn btn-green btn-full"
                                @click="$emit('modalActive')"
                        >Further</button>
                    </div>


                </div>
            </div>
            <transition name="fade">
                <div class="info__blck desktop__blck" v-if="infOpen">
                    <div class="logo__blck">
                        <p class="p-bold title-p">More about Fortum</p>
                        <p class="min-min">Cheap, cheap and cheap. Then you can summarize Telinet Energi with three words. For us, the price is everything. At the same time, we never compromise on the environment: all our electricity is green and comes from renewable sources.</p>
                    </div>
                    <div class="price__blck">
                        <div class="price_info_item">
                            <p class="p-bold title-p">Fixed charge</p>
                            <p class="min-min">The regular fixed annual fee is SEK 420 incl. VAT </p>
                        </div>
                        <div class="price_info_item">
                            <p class="p-bold title-p">Discount fixed fee</p>
                            <p class="min-min">The anual fee is discounted SEK 420 / year incl. VAT for one year</p>
                        </div>
                        <div class="price_info_item">
                            <p class="p-bold title-p">Discount penny / kWh</p>
                            <p class="min-min">SEK 8.00 / kWh excluding VAT</p>
                        </div>
                    </div>
                    <div class="action__blck">
                        <div class="row">
                            <div class="col-9">
                                <div class="title">
                                    <p class="relawaySM min p-dgrey">Electricity price</p>
                                    <p class="p-gray2 minimum">(incl. electricity certificate, excl. VAT)</p>
                                </div>
                            </div>
                            <div class="col-3 d-flex align-items-center justify-content-end">
                                <div class="cost">
                                    <p class="p-dgrey med-max p-bold">45.90</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-9">
                                <div class="title">
                                    <p class="relawaySM min p-dgrey"> Fixed feese</p>
                                    <p class="p-gray2 minimum">Monthly fee 36 SEK / month (excl. VAT)</p>
                                </div>
                            </div>
                            <div class="col-3 d-flex align-items-center justify-content-end">
                                <div class="cost">
                                    <p class="p-dgrey med-max p-bold">3.51</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-9">
                                <div class="title">
                                    <p class="relawaySM min p-dgrey">Environmental Power on</p>
                                    <p class="p-gray2 minimum">No premium for environmental agreements</p>
                                </div>
                            </div>
                            <div class="col-3 d-flex align-items-center justify-content-end">
                                <div class="cost">
                                    <p class="p-dgrey med-max p-bold">0.00</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-9">
                                <div class="title">
                                    <p class="relawaySM min p-dgrey">Moms</p>
                                    <p class="p-gray2 minimum">VAT, 25% </p>
                                </div>
                            </div>
                            <div class="col-3 d-flex align-items-center justify-content-end">
                                <div class="cost">
                                    <p class="p-dgrey med-max p-bold">+ 12.35</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    export default {
        name: "newOfferResultItem",
        data: function () {
         return {
             active1: false,
             active2: false,
             active4: false,
             active5: false,
             active6: false,
             active7: false,
             active8: false,
             active3: true,
             infOpen: false
             }
        },
        props: [
            'localItem',
            'keyItem',
            'itemData',

        ],

    }
</script>
